import Display from "./Display";
import ButtonArray from "./ButtonArray";

const MainContainer = () => {
  return (
    
    <>
      <div className="main-container">
        <Display />
        <ButtonArray />
      </div>
    </>
  );
};

export default MainContainer;
